<div class="eia">
  <div class="eia-marco">
    <!-- Cabecera del módulo con las pestañas: sólo dentro de una evaluación.
         En la lista no sale (pedido de Norman, 23/09/2026): repetía el título
         de la pantalla y no había entre qué pestañas moverse. -->
    @if (vista !== "lista") {
    <header
      class="eia-cabecera eia-cabecera--fija eia-cabecera--una-fila"
      [class.eia-cabecera--sin-datos]="!(sel && res && vista === 'evaluacion')"
    >
      <!-- Quién se está evaluando y en qué paso, en la barra fija (pedido de
           Norman, 23/09/2026: en lugar de «Evaluación de proveedores de IA»).
           Así sigue a la vista al bajar, en las tres pestañas. -->
      <div class="eia-cabecera__titulo">
        @if (nombreBarra) {
          <div class="eia-id">
            <span class="eia-avatar eia-avatar--40" [style.background]="colorSel" aria-hidden="true">{{ iniSel }}</span>
            <div class="eia-id__txt">
              <div class="eia-id__paso">{{ pasoTexto }}</div>
              <h1 class="eia-id__nombre" [attr.title]="nombreBarra">{{ nombreBarra }}</h1>
              <!-- Debajo del nombre, la línea de estado (o quién firmó). -->
              @if (sel && res) {
                <p class="eia-cab__nota eia-id__nota" [class.eia-cab__nota--firmada]="firmada">
                  @if (firmada) {
                    <span class="eia-cab__candado" aria-hidden="true">🔒</span>
                    <strong>{{ dictamenFirmado }}</strong> · {{ firmaNota }}.
                    @if (vista !== "resultado") {
                      Para cambiar algo, reábrela en Resultado.
                    }
                  } @else {
                    {{ notaVista }}
                  }
                </p>
              }
            </div>
          </div>
        } @else {
          <div class="eia-marca">Evaluación de proveedores de IA</div>
        }
      </div>
      <!-- Los pasos sólo existen cuando hay un proveedor abierto. En la pantalla
           de la lista no se enseña ninguno: ahí no hay entre qué navegar —lo
           único que se puede hacer es abrir un proveedor— y antes se veían los
           tres, dos de ellos deshabilitados y sin llevar a ningún lado. -->
      @if (vista !== "lista") {
        <nav class="eia-tabs" role="tablist" aria-label="Pasos de la evaluación">
          @for (t of TABS; track t.id) {
            <button
              type="button"
              role="tab"
              class="eia-tab"
              [class.eia-tab--activa]="vista === t.id"
              [attr.aria-selected]="vista === t.id"
              [disabled]="t.id === 'lista' || (t.id === 'resultado' && !puedeVerResultado && vista !== 'resultado')"
              [attr.title]="
                t.id === 'lista'
                  ? 'Usa «Cancelar» o termina firmando en Resultado'
                  : t.id === 'resultado' && !puedeVerResultado && vista !== 'resultado'
                    ? 'Para ver el resultado falta ' + faltaResultadoTexto
                    : null
              "
              (click)="irVista(t.id)"
            >
              <span class="eia-tab__n" aria-hidden="true">{{ t.n }}</span>
              <span class="eia-tab__txt">{{ t.label }}</span>
            </button>
          }
        </nav>
      }
      @if (vista !== "lista") {
        <button
          type="button"
          class="eia-cancelar"
          [disabled]="saliendo || firmando || reabriendo"
          [attr.aria-busy]="saliendo"
          title="Regresa a Proveedores. Lo que estés escribiendo se guarda antes de salir."
          (click)="cancelar()"
        >
          <span class="eia-cancelar__x" aria-hidden="true">✕</span>
          <span>{{ saliendo ? "Guardando…" : "Cancelar" }}</span>
        </button>
      }
      <!-- Los números de la pestaña, en la misma barra fija (pedido de Norman,
           23/09/2026): sólo en el cuestionario, el avance y el puntaje. El
           expediente lleva su tarjeta de estado, con «Ver resultado», al
           inicio de la pestaña; el resultado no lleva nada aquí (el regreso
           «← Expediente» se quitó el 23/09/2026: para eso está la pestaña). -->
      @if (sel && res && vista === "evaluacion") {
        <div class="eia-cab__lado eia-cabecera__datos">
          <div class="eia-cab__dato eia-cab__dato--avance">
            <span class="eia-cab__et">Avance</span>
            <span class="eia-cab__val">{{ res.avance }}%<small>{{ res.respondidos }} de {{ res.totalCriterios }}</small></span>
            <span class="eia-barra eia-barra--fina eia-cab__barra">
              <span class="eia-barra__relleno" [style.width.%]="res.avance" [style.background]="colorSel"></span>
            </span>
          </div>
          <div class="eia-cab__dato">
            <span class="eia-cab__et">Puntaje</span>
            <span class="eia-cab__val">{{ puntajeTexto }}<small>/100 · pasa con {{ res.umbral }}</small></span>
          </div>
        </div>
      }
    </header>
    }

    <main class="eia-cuerpo">
      <!-- ══════════════ 1 · PROVEEDORES ══════════════ -->
      @if (vista === "lista") {
        <section class="eia-seccion eia-seccion--angosta eia-seccion--lista">
          <div class="eia-encabezado">
            <div class="eia-encabezado__texto">
              <h1 class="eia-h1 eia-h1--grande">Proveedores de IA</h1>
              <p class="eia-bajada">Cada proveedor con su cuestionario, su expediente y su dictamen firmado.</p>
            </div>
            <button type="button" class="eia-btn eia-btn--primario" (click)="abrirNuevo()">+ Nueva evaluación</button>
          </div>

          @if (nuevoAbierto) {
            <form class="eia-nuevo" (ngSubmit)="crear()">
              <div class="eia-campo eia-nuevo__campo">
                <div class="eia-campo__cabeza">
                  <label for="eia-nuevo-nombre">Proveedor / herramienta <span class="eia-req" aria-hidden="true">*</span></label>
                  <span class="eia-contador">{{ nuevoNombre.length }}/120</span>
                </div>
                <input
                  id="eia-nuevo-nombre"
                  class="eia-input"
                  name="nuevoNombre"
                  [(ngModel)]="nuevoNombre"
                  maxlength="120"
                  required
                  autocomplete="off"
                  placeholder="Ej. Mistral AI — Le Chat Enterprise"
                />
              </div>
              <div class="eia-campo eia-nuevo__campo">
                <div class="eia-campo__cabeza">
                  <label for="eia-nuevo-caso">Caso de uso previsto en {{ EMPRESA }} <span class="eia-req" aria-hidden="true">*</span></label>
                  <span class="eia-contador">{{ nuevoCaso.length }}/300</span>
                </div>
                <input
                  id="eia-nuevo-caso"
                  class="eia-input"
                  name="nuevoCaso"
                  [(ngModel)]="nuevoCaso"
                  maxlength="300"
                  required
                  autocomplete="off"
                  placeholder="Ej. Redacción de documentación interna"
                />
              </div>
              <div class="eia-nuevo__acciones">
                <button type="submit" class="eia-btn eia-btn--primario" [disabled]="creando || !nuevoNombre.trim() || !nuevoCaso.trim()">
                  {{ creando ? "Creando…" : "Crear expediente" }}
                </button>
                <button type="button" class="eia-btn eia-btn--secundario" (click)="cerrarNuevo()">Cancelar</button>
              </div>
            </form>
          }

          <div class="eia-kpis">
            @for (k of kpis; track k.label) {
              <div class="eia-kpi" [attr.data-tono]="k.tono">
                <div class="eia-etiqueta">{{ k.label }}</div>
                <div class="eia-kpi__fila">
                  <span class="eia-kpi__num" [attr.data-tono]="k.tono">{{ k.val }}</span>
                  <span class="eia-kpi__sub">{{ k.sub }}</span>
                </div>
              </div>
            }
          </div>

          @if (cargandoLista && !filas.length) {
            <div class="eia-vacio">Cargando proveedores…</div>
          } @else if (errorLista) {
            <div class="eia-vacio eia-vacio--error">
              {{ errorLista }}
              <button type="button" class="eia-btn eia-btn--secundario eia-btn--chico" (click)="cargarLista()">Reintentar</button>
            </div>
          } @else if (!filas.length) {
            <div class="eia-vacio">Todavía no hay expedientes. Crea el primero con «+ Nueva evaluación».</div>
          } @else {
            <div class="eia-scroll">
              <table class="eia-tabla eia-tabla--proveedores">
                <thead>
                  <tr>
                    <!-- Sin anchos a mano, como las tablas de Inventario IA: el
                         reparto lo hace el navegador y el CSS sólo dice cuál es
                         la columna que estira (Proveedor). Antes iban en
                         porcentajes fijos y a Dictamen se le daba un 22% que su
                         texto no usa ni de lejos: ese sobrante era el hueco
                         blanco que quedaba justo antes de los botones. -->
                    <th>Proveedor</th>
                    <th>Avance</th>
                    <th>Puntaje</th>
                    <th>Riesgo</th>
                    <th>Dictamen</th>
                    <th><span class="eia-oculto-visual">Acciones</span></th>
                  </tr>
                </thead>
                <tbody>
                  @for (f of filasPagina; track f.id) {
                    <tr>
                      <td>
                        <div class="eia-prov">
                          <span class="eia-avatar" [style.background]="f.color" aria-hidden="true">{{ f.ini }}</span>
                          <div class="eia-prov__texto">
                            <button type="button" class="eia-prov__nombre" (click)="abrir(f.id)">{{ f.nombre }}</button>
                            <div class="eia-prov__servicio">{{ f.servicio }}</div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="eia-avance">
                          <div class="eia-barra eia-barra--64">
                            <div class="eia-barra__relleno" [style.width.%]="f.avance" [style.background]="f.color"></div>
                          </div>
                          <span class="eia-avance__pct">{{ f.avance }}%</span>
                        </div>
                      </td>
                      <td class="eia-num">
                        <span class="eia-puntaje">{{ f.puntaje }}</span>
                        <span class="eia-puntaje__nota">{{ f.puntajeNota }}</span>
                      </td>
                      <td><span class="eia-tag" [attr.data-riesgo]="f.riesgo">{{ RIESGO_TEXTO[f.riesgo] }}</span></td>
                      <td class="eia-celda-dictamen" [class.eia-celda-dictamen--firmada]="f.firmada">{{ f.dictamen }}</td>
                      <td class="eia-td-accion">
                        <span class="eia-acciones">
                          <!-- Una evaluación firmada ya no se toca: ni editar sus
                               datos ni eliminarla. Los dos botones se van juntos y
                               la fila se queda sólo con "Abrir →", que es consulta.
                               OJO: el lápiz era además la única puerta al modal de
                               "Datos y bitácora", así que la bitácora de una
                               firmada deja de verse desde aquí. -->
                          @if (!f.firmada) {
                            <button
                              type="button"
                              class="eia-btn eia-btn--editar"
                              [attr.aria-label]="'Editar ' + f.nombre"
                              title="Editar datos del proveedor"
                              (click)="editar(f)"
                            >
                              <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
                                <path fill="currentColor" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zm17.71-10.21a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                              </svg>
                            </button>
                            <button
                              type="button"
                              class="eia-btn eia-btn--eliminar"
                              [attr.aria-label]="'Eliminar ' + f.nombre"
                              title="Eliminar (pide PIN)"
                              (click)="eliminar(f)"
                            >
                              <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
                                <path fill="currentColor" d="M9 3h6l1 2h4v2H4V5h4l1-2zM6 9h12l-1 12H7L6 9zm4 2v8h2v-8h-2zm4 0v8h2v-8h-2z" />
                              </svg>
                            </button>
                          }
                          <button type="button" class="eia-btn eia-btn--secundario eia-btn--chico eia-btn--abrir" (click)="abrir(f.id)">Abrir →</button>
                        </span>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            @if (totalPaginas > 1) {
              <nav class="eia-paginado" aria-label="Páginas de proveedores">
                <span class="eia-paginado__rango">{{ rangoTexto }}</span>
                <div class="eia-paginado__botones">
                  <button type="button" class="eia-pag" [disabled]="pagina === 1" (click)="irPagina(pagina - 1)">← Anterior</button>
                  @for (n of paginas; track n) {
                    <button
                      type="button"
                      class="eia-pag eia-pag--num"
                      [class.eia-pag--activa]="n === pagina"
                      [attr.aria-current]="n === pagina ? 'page' : null"
                      [attr.aria-label]="'Página ' + n"
                      (click)="irPagina(n)"
                    >
                      {{ n }}
                    </button>
                  }
                  <button type="button" class="eia-pag" [disabled]="pagina === totalPaginas" (click)="irPagina(pagina + 1)">Siguiente →</button>
                </div>
              </nav>
            }
          }
        </section>
      }

      <!-- ══════════════ 2 · CUESTIONARIO ══════════════
           Sólo las preguntas, a todo lo ancho (pedido de Norman, 23/09/2026:
           «se ve mucha información junta»). Los datos del proveedor, el
           resumen y la evidencia pasaron a su propia pestaña, el expediente,
           a la que se llega con «Terminar» en la última sección. -->
      @if (vista === "evaluacion") {
        @if (sel && res) {
          <section class="eia-seccion eia-seccion--cuestionario">



            <!-- Los datos del proveedor van en el cuestionario, arriba de las
                 preguntas (pedido de Norman, 23/09/2026): son parte de lo que
                 se llena aquí, y «Terminar» los pide junto con las respuestas. -->
            <div class="eia-bloque__cabeza">
              <h2 class="eia-h4">Datos del proveedor</h2>
              <span class="eia-mini">Obligatorios para terminar y firmar · se guardan al salir de cada campo.</span>
            </div>
            <div class="eia-datos">
              <div class="eia-campo">
                <div class="eia-campo__cabeza">
                  <label for="eia-razon">Razón social / entidad <span class="eia-req" aria-hidden="true">*</span></label>
                  <span class="eia-contador">{{ datos.razonSocial.length }}/150</span>
                </div>
                <input
                  id="eia-razon"
                  class="eia-input"
                  [class.eia-input--falta]="!firmada && !datos.razonSocial.trim()"
                  [attr.aria-invalid]="!firmada && !datos.razonSocial.trim()"
                  [(ngModel)]="datos.razonSocial"
                  (change)="guardarDatos()"
                  maxlength="150"
                  required
                  [disabled]="firmada"
                />
                @if (!firmada && !datos.razonSocial.trim()) {
                  <span class="eia-campo__falta">Obligatorio para firmar</span>
                }
              </div>
              <div class="eia-campo">
                <div class="eia-campo__cabeza">
                  <label for="eia-servicio">Servicio contratado <span class="eia-req" aria-hidden="true">*</span></label>
                  <span class="eia-contador">{{ datos.servicio.length }}/150</span>
                </div>
                <input
                  id="eia-servicio"
                  class="eia-input"
                  [class.eia-input--falta]="!firmada && !datos.servicio.trim()"
                  [attr.aria-invalid]="!firmada && !datos.servicio.trim()"
                  [(ngModel)]="datos.servicio"
                  (change)="guardarDatos()"
                  maxlength="150"
                  required
                  [disabled]="firmada"
                />
                @if (!firmada && !datos.servicio.trim()) {
                  <span class="eia-campo__falta">Obligatorio para firmar</span>
                }
              </div>
              <div class="eia-campo">
                <div class="eia-campo__cabeza">
                  <label for="eia-plan">Plan / modalidad <span class="eia-req" aria-hidden="true">*</span></label>
                  <span class="eia-contador">{{ datos.planModalidad.length }}/100</span>
                </div>
                <input
                  id="eia-plan"
                  class="eia-input"
                  [class.eia-input--falta]="!firmada && !datos.planModalidad.trim()"
                  [attr.aria-invalid]="!firmada && !datos.planModalidad.trim()"
                  [(ngModel)]="datos.planModalidad"
                  (change)="guardarDatos()"
                  maxlength="100"
                  required
                  [disabled]="firmada"
                />
                @if (!firmada && !datos.planModalidad.trim()) {
                  <span class="eia-campo__falta">Obligatorio para firmar</span>
                }
              </div>
              <div class="eia-campo">
                <div class="eia-campo__cabeza">
                  <label for="eia-fecha">Fecha de evaluación <span class="eia-req" aria-hidden="true">*</span></label>
                </div>
                <input
                  id="eia-fecha"
                  type="date"
                  class="eia-input"
                  [class.eia-input--falta]="!firmada && !datos.fechaEvaluacion"
                  [attr.aria-invalid]="!firmada && !datos.fechaEvaluacion"
                  [(ngModel)]="datos.fechaEvaluacion"
                  (change)="guardarDatos()"
                  [max]="hoy"
                  required
                  [disabled]="firmada"
                />
                @if (!firmada && !datos.fechaEvaluacion) {
                  <span class="eia-campo__falta">Obligatorio para firmar</span>
                }
              </div>
              <div class="eia-datos__estado" aria-live="polite">{{ textoGuardado }}</div>
            </div>

            <div class="eia-cuestionario">
              <aside class="eia-aside">
                <div class="eia-aside__cabeza">
                  <span class="eia-etiqueta">Secciones del cuestionario</span>
                  <span class="eia-mini">{{ totalDominios }} secciones · 100%</span>
                </div>
                <div class="eia-aside__lista">
                  @for (d of navDom; track d.id) {
                    <button
                      type="button"
                      class="eia-dom"
                      [class.eia-dom--activo]="d.id === dom"
                      [style.--dom]="d.color"
                      [attr.aria-current]="d.id === dom ? 'step' : null"
                      (click)="elegirDominio(d.id)"
                    >
                      <span class="eia-chip" aria-hidden="true">{{ d.num }}</span>
                      <span class="eia-dom__info">
                        <span class="eia-dom__nombre">{{ d.nombre }}</span>
                        <span class="eia-dom__progreso" [title]="'Lleva ' + d.aporteTexto + ' de los ' + d.peso + ' puntos de la sección'">
                          <span class="eia-barra eia-barra--fina"><span class="eia-barra__relleno" [style.width.%]="d.score"></span></span>
                          <span class="eia-mini eia-num eia-dom__peso"><strong>{{ d.aporteTexto }}</strong>/{{ d.peso }}</span>
                        </span>
                        <span class="eia-mini eia-dom__detalle">
                          <span class="eia-num eia-dom__cumplen">{{ d.cumplen }}/{{ d.total }} Sí</span>
                          @if (d.nota) {
                            <span class="eia-dom__nota">· {{ d.nota }}</span>
                          }
                        </span>
                      </span>
                    </button>
                  }
                </div>
              </aside>

              <div class="eia-panel" [style.--dom]="colorDom(dom)">
                @if (domActual) {
                  <div class="eia-panel__cabeza">
                    <span class="eia-chip eia-chip--44" aria-hidden="true">{{ domNum }}</span>
                    <div class="eia-panel__titulos">
                      <div class="eia-mini-fuerte">Sección {{ domNum }} de {{ totalDominios }} · peso {{ pesoActual }}% entre {{ domActual.criterios.length }} preguntas</div>
                      <h3 class="eia-h3">{{ domActual.nombre }}</h3>
                      <p class="eia-panel__desc">{{ domActual.descripcion }}</p>
                    </div>
                  </div>
                }

                <div class="eia-preguntas">
                  @for (p of preguntas; track p.c.clave) {
                    <div class="eia-pregunta">
                      <div class="eia-pregunta__id">
                        <div class="eia-pregunta__num">Pregunta {{ p.c.numero }}</div>
                      </div>

                      <div class="eia-pregunta__cuerpo">
                        <div class="eia-pregunta__texto">{{ p.c.texto }}</div>
                        @if (p.editando) {
                          <div class="eia-obs-edicion">
                            <textarea
                              class="eia-input eia-textarea"
                              rows="3"
                              maxlength="1000"
                              [readonly]="p.guardando"
                              [(ngModel)]="p.borrador"
                              [attr.aria-label]="'Observación de la pregunta ' + p.c.numero"
                              [placeholder]="p.respuesta === 'NO_CUMPLE' ? 'Qué no cumple y dónde se vio' : 'Qué se revisó y dónde consta'"
                            ></textarea>
                            <div class="eia-obs-edicion__acciones">
                              <button type="button" class="eia-btn eia-btn--primario eia-btn--chico" [disabled]="p.guardando" (click)="guardarObs(p)">
                                {{ p.guardando ? "Guardando…" : "Guardar" }}
                              </button>
                              <button type="button" class="eia-btn eia-btn--secundario eia-btn--chico" (click)="cancelarObs(p)">Cancelar</button>
                              <span class="eia-contador">{{ p.borrador.length }}/1000</span>
                            </div>
                          </div>
                        } @else if (p.observacion) {
                          <div class="eia-obs" [class.eia-obs--hallazgo]="p.respuesta === 'NO_CUMPLE'">
                            <span class="eia-obs__titulo">{{ p.respuesta === "NO_CUMPLE" ? "Hallazgo:" : "Observación:" }}</span>
                            {{ p.observacion }}
                            @if (!firmada) {
                              <button type="button" class="eia-enlace eia-enlace--mini" (click)="editarObs(p)">Editar</button>
                            }
                          </div>
                        } @else if (!firmada) {
                          <button type="button" class="eia-enlace eia-enlace--agregar" (click)="editarObs(p)">
                            {{ p.respuesta === "NO_CUMPLE" ? "+ Anotar el hallazgo" : "+ Anotar observación" }}
                          </button>
                        }
                      </div>

                      <div class="eia-opciones" role="group" [attr.aria-label]="'Respuesta a la pregunta ' + p.c.numero">
                        <button
                          type="button"
                          class="eia-opcion eia-opcion--si"
                          [class.eia-opcion--activa]="p.respuesta === 'CUMPLE'"
                          [attr.aria-pressed]="p.respuesta === 'CUMPLE'"
                          [disabled]="firmada"
                          (click)="responder(p, 'CUMPLE')"
                        >
                          Sí cumple
                        </button>
                        <button
                          type="button"
                          class="eia-opcion eia-opcion--no"
                          [class.eia-opcion--activa]="p.respuesta === 'NO_CUMPLE'"
                          [attr.aria-pressed]="p.respuesta === 'NO_CUMPLE'"
                          [disabled]="firmada"
                          (click)="responder(p, 'NO_CUMPLE')"
                        >
                          No cumple
                        </button>
                      </div>
                    </div>
                  }
                </div>

                <div class="eia-panel__pie">
                  <button type="button" class="eia-btn eia-btn--secundario" [disabled]="domNum === 1" (click)="domAnterior()">← Anterior</button>
                  <!-- Un solo botón que cambia de texto: en la última sección ya
                       no hay «siguiente», se termina y se pasa al expediente
                       (domSiguiente llama a terminarCuestionario). Es el mismo
                       nodo, así que el foco del teclado no se pierde al llegar.
                       Apagado mientras falte una respuesta, con el motivo al lado. -->
                  <button
                    type="button"
                    class="eia-btn eia-btn--primario"
                    [disabled]="domNum === totalDominios && !puedeTerminar"
                    [attr.title]="domNum === totalDominios && !puedeTerminar ? avisoTerminar : null"
                    (click)="domSiguiente()"
                  >
                    {{ domNum < totalDominios ? "Siguiente →" : firmada ? "Ver expediente →" : "Terminar ✓" }}
                  </button>
                  @if (domNum === totalDominios && !puedeTerminar) {
                    <span class="eia-panel__falta" role="status">{{ avisoTerminar }}</span>
                  }
                  @if (!firmada) {
                    <span class="eia-panel__pie-derecha">
                      <button type="button" class="eia-btn eia-btn--secundario" [disabled]="!respondidasLocal" (click)="limpiarCuestionario()">
                        Limpiar cuestionario
                      </button>
                    </span>
                  }
                </div>
              </div>
            </div>
          </section>
        } @else {
          <ng-container [ngTemplateOutlet]="eiaCargando"></ng-container>
        }
      }

      <!-- ══════════════ 3 · EXPEDIENTE ══════════════
           Lo que se llena fuera del cuestionario: los datos del proveedor
           (obligatorios para firmar), el resumen y la evidencia documental
           de lo que quedó en Sí cumple. De aquí se va al resultado. -->
      @if (vista === "expediente") {
        @if (sel && res) {
          <section class="eia-seccion eia-seccion--expediente">
            <!-- Estado del expediente (pedido de Norman, 23/09/2026: «esto sí en
                 expediente, pero mejor acomodado»): la evidencia y el dictamen,
                 los tres requisitos para ver el resultado con su palomita o su
                 tache, y «Ver resultado» sólo cuando los tres están cumplidos.
                 El puntaje no va aquí: se ve en la barra del cuestionario. -->
            <div class="eia-estado">
              <div
                class="eia-cab__dato"
                [attr.data-ok]="expedienteHabilitado ? evidenciaConArchivo === evidenciaRequerida : 'pendiente'"
              >
                <span class="eia-cab__et">Evidencia</span>
                @if (expedienteHabilitado) {
                  <span class="eia-cab__val">{{ evidenciaConArchivo }} de {{ evidenciaRequerida }}<small>{{ evidenciaConArchivo === evidenciaRequerida ? "completa" : "falta archivo" }}</small></span>
                } @else {
                  <span class="eia-cab__val">—<small>pendiente</small></span>
                }
              </div>
              <div class="eia-cab__dato">
                <span class="eia-cab__et">Dictamen</span>
                <span class="eia-cab__val eia-cab__val--texto">{{ dictamenActual }}</span>
              </div>
              @if (!firmada) {
                <div class="eia-estado__req" role="list" aria-label="Para ver el resultado">
                  <span class="eia-estado__req-et">Para ver el resultado</span>
                  @for (q of requisitosResultado; track q.texto) {
                    <span class="eia-falta-item" role="listitem" [class.eia-falta-item--ok]="q.ok">
                      <span class="eia-falta-item__ico" aria-hidden="true">{{ q.ok ? "✓" : "✕" }}</span>
                      <span class="eia-oculto-visual">{{ q.ok ? "Cumplido:" : "Falta:" }}</span>
                      {{ q.texto }}
                    </span>
                  }
                </div>
              }
              @if (puedeVerResultado) {
                <div class="eia-estado__accion">
                  <button type="button" class="eia-btn eia-btn--primario" (click)="irVista('resultado')">Ver resultado →</button>
                </div>
              }
            </div>








            <div class="eia-docs__cabeza">
              <h2 class="eia-h4">Evidencia documental</h2>
              @if (expedienteHabilitado) {
                <span class="eia-mini-12">{{ docsResumen }}</span>
              }
              <span class="eia-mini eia-empuja">No suma puntos. En Sí cumple, el archivo es obligatorio para aprobar.</span>
            </div>
            @if (!expedienteHabilitado) {
              <div class="eia-vacio eia-expediente__bloqueado" role="status">
                <strong>La evidencia se habilita al terminar el cuestionario.</strong>
                <span>{{ expedienteAviso }}</span>
                <button type="button" class="eia-btn eia-btn--secundario eia-btn--chico" (click)="irVista('evaluacion')">Ir al cuestionario</button>
              </div>
            } @else {
              <div class="eia-docs">
                @for (d of docs; track d.cat.clave) {
                  <div class="eia-doc" [attr.data-estado]="d.estado">
                    <div class="eia-doc__fila">
                      <span class="eia-doc__info">
                        <span class="eia-doc__nombre">{{ d.cat.nombre }}</span>
                        <span class="eia-doc__crit">{{ d.criterio }}</span>
                      </span>
                      <span class="eia-estado-doc" [attr.data-estado]="d.estado">
                        {{ d.estado === "CUMPLE" ? "Sí cumple" : d.estado === "NO_CUMPLE" ? "No cumple" : "Sin responder" }}
                      </span>
                      @if (d.estado === "CUMPLE" && !firmada && d.idEvalDoc) {
                        <label class="eia-subir" [class.eia-subir--ocupado]="d.subiendo" [class.eia-subir--hay]="d.archivos.length">
                          <input
                            type="file"
                            class="eia-oculto"
                            [disabled]="d.subiendo"
                            accept=".pdf,.jpg,.jpeg,.png,.gif,.webp,.bmp,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.csv,.txt,.zip,.msg,.eml"
                            (change)="subir(d, $event)"
                          />
                          {{ d.subiendo ? "Subiendo…" : d.archivos.length ? "Agregar archivo" : "Subir evidencia" }}
                        </label>
                      }
                    </div>

                    @if (d.estado === "CUMPLE") {
                      <div class="eia-doc__ref">
                        <input
                          class="eia-input eia-input--chico"
                          [(ngModel)]="d.referencia"
                          (ngModelChange)="d.sucia = true"
                          (blur)="guardarReferencia(d)"
                          maxlength="500"
                          placeholder="Enlace o ubicación donde consta"
                          [attr.title]="d.referencia || null"
                          [disabled]="firmada"
                          [attr.aria-label]="'Dónde consta: ' + d.cat.nombre"
                        />
                        @if (esEnlace(d.referencia)) {
                          <a class="eia-enlace eia-enlace--mini" [href]="d.referencia" target="_blank" rel="noopener noreferrer">Abrir</a>
                        }
                      </div>
                      @if (d.sinGuardar && !firmada) {
                        <div class="eia-doc__falta" role="alert">No se guardó dónde consta: sal del campo para volver a intentarlo.</div>
                      }
                      <div class="eia-doc__archivos">
                        @for (a of d.archivos; track a.idEvidencia) {
                          <div class="eia-archivo">
                            <button
                              type="button"
                              class="eia-enlace eia-archivo__nombre"
                              [attr.aria-describedby]="vistazo && vistazo.a.idEvidencia === a.idEvidencia ? 'eia-vistazo' : null"
                              (click)="verArchivo(a)"
                              (mouseenter)="abreVistazo(a, $event)"
                              (mouseleave)="cierraVistazo()"
                              (focus)="abreVistazo(a, $event)"
                              (blur)="cierraVistazo()"
                            >
                              {{ a.nombreArchivo }}
                            </button>
                            @if (!firmada) {
                              <button type="button" class="eia-btn eia-btn--fantasma eia-btn--mini" (click)="quitarArchivo(d, a)">Quitar</button>
                            }
                          </div>
                        } @empty {
                          <span class="eia-mini">Sin archivo adjunto</span>
                        }
                      </div>
                      @if (d.sinRespaldo && !firmada) {
                        <div class="eia-doc__falta">Obligatorio para aprobar: sube la evidencia (archivo).</div>
                      }
                    } @else {
                      <div class="eia-doc__nota">
                        {{
                          d.estado === "NO_CUMPLE"
                            ? "Sin evidencia: esta pregunta está en No cumple."
                            : "Responde esta pregunta en el cuestionario para adjuntar evidencia."
                        }}
                      </div>
                    }
                  </div>
                }
              </div>
            }

            <!-- Un solo «Ver resultado»: el de la cabecera, que se ve sin
                 bajar. Aquí sólo el regreso al cuestionario. -->
            <div class="eia-expediente__pie">
              <button type="button" class="eia-btn eia-btn--secundario" (click)="irVista('evaluacion')">← Cuestionario</button>
            </div>
          </section>
        } @else {
          <ng-container [ngTemplateOutlet]="eiaCargando"></ng-container>
        }
      }

      <!-- Mientras llega el detalle, o si falló: lo mismo en las dos pestañas. -->
      <ng-template #eiaCargando>
          <section class="eia-seccion">
            @if (errorDetalle) {
              <div class="eia-vacio eia-vacio--error">
                {{ errorDetalle }}
                <button type="button" class="eia-btn eia-btn--secundario eia-btn--chico" (click)="reintentarDetalle()">Reintentar</button>
              </div>
            } @else {
              <div class="eia-vacio">Abriendo el expediente…</div>
            }
          </section>
      </ng-template>

      <!-- ══════════════ 3 · RESULTADO ══════════════ -->
      @if (vista === "resultado") {
        @if (sel && res) {
          <section class="eia-seccion eia-seccion--angosta">

            <div class="eia-resumen">
              <div class="eia-caja">
                <div class="eia-etiqueta">Puntaje del cuestionario</div>
                <div class="eia-puntaje-grande">{{ puntajeTexto }}<span class="eia-puntaje-grande__de"> /100</span></div>
                <div class="eia-mini-125">avance {{ res.avance }}% · cumple con {{ res.umbral }} o más</div>
              </div>
              <div class="eia-caja">
                <div class="eia-etiqueta">Nivel de riesgo</div>
                <div class="eia-caja__tag"><span class="eia-tag eia-tag--grande" [attr.data-riesgo]="res.riesgo">{{ RIESGO_TEXTO[res.riesgo] }}</span></div>
                <div class="eia-mini-125 eia-caja__nota">{{ riesgoNota }}</div>
              </div>
              <div class="eia-caja">
                <div class="eia-etiqueta">Dictamen</div>
                <div class="eia-caja__sugerido">{{ dictamenCaja }}</div>
              </div>
            </div>

            <div class="eia-veredicto" [attr.data-tono]="veredictoTono">
              <div class="eia-veredicto__fila">
                <span class="eia-veredicto__sello">{{ veredicto }}</span>
                <span class="eia-veredicto__nota">{{ veredictoNota }}</span>
              </div>
              <div class="eia-requisitos">
                @for (q of requisitos; track q.texto) {
                  <div class="eia-requisito">
                    <span class="eia-requisito__ico" [class.eia-requisito__ico--ok]="q.ok" aria-hidden="true">{{ q.ok ? "✓" : "✗" }}</span>
                    <span class="eia-requisito__texto">
                      <span class="eia-oculto-visual">{{ q.ok ? "Cumplido:" : "Sin cumplir:" }}</span>
                      {{ q.texto }}
                    </span>
                    <span class="eia-requisito__valor">{{ q.valor }}</span>
                  </div>
                }
              </div>
            </div>

            @if (res.puedeAprobar && sinRespaldo.length && !firmada) {
              <div class="eia-alerta eia-alerta--aviso" role="status">
                <div class="eia-alerta__titulo">
                  Para aprobar falta subir la evidencia de {{ sinRespaldo.length === 1 ? "un documento" : sinRespaldo.length + " documentos" }}
                </div>
                <p class="eia-alerta__texto">
                  En Sí cumple el archivo es obligatorio: {{ sinRespaldo.join(", ") }}. Se sube en el expediente (paso 3).
                </p>
              </div>
            }

            <div class="eia-final">
              <div class="eia-final__col">
                <h4 class="eia-h4 eia-h4--regla">Puntaje por sección</h4>
                <div class="eia-scroll">
                  <table class="eia-tabla eia-tabla--dominios">
                    <thead>
                      <tr>
                        <th>Sección</th>
                        <th style="width: 10%">Peso</th>
                        <th style="width: 13%">Avance</th>
                        <th style="width: 30%">Puntaje</th>
                        <th style="width: 12%">Aporte</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (d of dominiosVista; track d.id) {
                        <tr>
                          <td class="eia-td-135">{{ d.nombre }}</td>
                          <td class="eia-num eia-td-125">{{ d.peso }}%</td>
                          <td class="eia-num eia-td-125">{{ d.hechos }}/{{ d.total }}</td>
                          <td>
                            <div class="eia-avance">
                              <div class="eia-barra eia-barra--flex">
                                <div class="eia-barra__relleno" [style.width.%]="d.score ?? 0" [attr.data-nivel]="d.nivel"></div>
                              </div>
                              <span class="eia-score">{{ d.scoreTexto }}</span>
                            </div>
                          </td>
                          <td class="eia-num eia-td-125">{{ d.aporteTexto }}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="eia-final__col">
                <h4 class="eia-h4 eia-h4--regla">Dictamen</h4>
                @if (firmada) {
                  <div class="eia-firma">
                    <div class="eia-firma__dictamen" [attr.data-dictamen]="sel.dictamen">{{ dictamenFirmado }}</div>
                    <dl class="eia-firma__datos">
                      <div><dt>Firmó</dt><dd>{{ sel.firmo || "—" }}</dd></div>
                      <div><dt>Fecha de firma</dt><dd>{{ fechaFirmaTexto }}</dd></div>
                      <!-- Sin «Vigencia» ni «Próxima evaluación» (22/09/2026, pedido
                           de Norman): el dictamen de un proveedor de IA dice quién
                           firmó y cuándo, y ya. La vigencia se sigue guardando al
                           aprobar (vigencia_meses) y la próxima evaluación se sigue
                           calculando en el servidor; simplemente no se pintan. -->
                    </dl>
                    @if (sel.firmaDigital) {
                      <figure class="eia-firma__trazo">
                        <img [src]="sel.firmaDigital" [alt]="'Firma digital de ' + (sel.firmo || 'quien firmó')" />
                        <figcaption>Firma digital · {{ sel.firmo || "—" }}</figcaption>
                      </figure>
                    }
                    <div class="eia-firmar">
                      <button type="button" class="eia-btn eia-btn--secundario" [disabled]="reabriendo" (click)="reabrir()">
                        {{ reabriendo ? "Reabriendo…" : "Reabrir evaluación" }}
                      </button>
                      <span class="eia-mini-12">El motivo queda en la bitácora.</span>
                    </div>
                  </div>
                } @else {
                  <div class="eia-radios" role="radiogroup" aria-label="Dictamen">
                    <label class="eia-radio" [class.eia-radio--bloqueado]="!res.puedeAprobar">
                      <input
                        type="radio"
                        name="eia-dictamen"
                        class="eia-radio__input"
                        [checked]="dictamenElegido === 'APROBADO'"
                        [disabled]="!res.puedeAprobar"
                        (change)="elegirDictamen('APROBADO')"
                      />
                      <span class="eia-radio__punto" aria-hidden="true"></span>
                      <span class="eia-radio__textos">
                        <span class="eia-radio__titulo">Aprobado</span>
                        <span class="eia-radio__desc">
                          {{ res.puedeAprobar ? "Uso autorizado en los casos definidos." : "Bloqueado: se habilita cuando el cuestionario cumpla (todo respondido y " + res.umbral + " o más)." }}
                        </span>
                      </span>
                    </label>
                    <label class="eia-radio">
                      <input
                        type="radio"
                        name="eia-dictamen"
                        class="eia-radio__input"
                        [checked]="dictamenElegido === 'RECHAZADO'"
                        (change)="elegirDictamen('RECHAZADO')"
                      />
                      <span class="eia-radio__punto" aria-hidden="true"></span>
                      <span class="eia-radio__textos">
                        <span class="eia-radio__titulo">No aprobado</span>
                        <span class="eia-radio__desc">No se autoriza el uso; requiere remediación y nueva evaluación.</span>
                      </span>
                    </label>
                  </div>
                  <div class="eia-firmar">
                    <button type="button" class="eia-btn eia-btn--primario" [disabled]="!dictamenElegido || ocupado || datosSinGuardar || faltanDatos.length > 0 || (dictamenElegido === 'APROBADO' && sinRespaldo.length > 0)" (click)="firmar()">
                      {{ firmando ? "Firmando…" : ocupado ? "Guardando lo último…" : "Cerrar y firmar evaluación" }}
                    </button>
                    <span class="eia-mini-12">{{ firmaNota }}</span>
                  </div>
                }
              </div>
            </div>
          </section>
        } @else {
          <section class="eia-seccion">
            @if (errorDetalle) {
              <div class="eia-vacio eia-vacio--error">
                {{ errorDetalle }}
                <button type="button" class="eia-btn eia-btn--secundario eia-btn--chico" (click)="reintentarDetalle()">Reintentar</button>
              </div>
            } @else {
              <div class="eia-vacio">Abriendo el expediente…</div>
            }
          </section>
        }
      }
    </main>
  </div>

  <!-- La firma digital al cerrar: el mismo modal del FRC-019, sólo digital -->
  @if (firmaAbierta && sel) {
    <app-firma-frc
      para="autorizar"
      documento="EVAL-IA"
      [soloDigital]="true"
      [nombre]="sel.nombre"
      [leyenda]="firmaLeyenda"
      (firmada)="alFirmar($event)"
      (cancelada)="cierraFirma()"
    ></app-firma-frc>
  }

  <!-- Editar desde la tabla: los datos del proveedor y, debajo, su bitácora de cambios -->
  @if (edicion) {
    <div class="eia-modal" role="dialog" aria-modal="true" aria-labelledby="eia-editar-titulo" (keydown.tab)="atrapaFoco($event)" (keydown.shift.tab)="atrapaFoco($event)">
      <div class="eia-modal__fondo" (click)="cerrarEdicion(true)" (keydown.enter)="cerrarEdicion(true)"></div>
      <div class="eia-modal__caja">
        <div class="eia-modal__cabeza">
          <div class="eia-modal__titulos">
            <div class="eia-kicker">{{ edicion.firmada ? "Firmada · sólo consulta" : "Editar proveedor" }}</div>
            <h2 id="eia-editar-titulo" class="eia-h2 eia-modal__titulo">{{ edicion.nombre }}</h2>
          </div>
          <button type="button" class="eia-btn eia-btn--fantasma eia-modal__cerrar" aria-label="Cerrar" [disabled]="guardandoEdicion" (click)="cerrarEdicion(true)">✕</button>
        </div>

        <!-- Datos y bitácora en pestañas, no uno debajo del otro: la bitácora
             crece con cada cambio y empujaba los campos fuera de la vista. Las
             dos van DENTRO del form para que el pie con Guardar / Cancelar se
             quede siempre abajo, se mire la pestaña que se mire. -->
        <nav class="eia-modal__tabs" role="tablist" aria-label="Secciones del proveedor">
          <button
            type="button"
            role="tab"
            class="eia-modal__tab"
            [class.eia-modal__tab--activa]="tabEdicion === 'datos'"
            [attr.aria-selected]="tabEdicion === 'datos'"
            (click)="tabEdicion = 'datos'"
          >
            Datos
          </button>
          <button
            type="button"
            role="tab"
            class="eia-modal__tab"
            [class.eia-modal__tab--activa]="tabEdicion === 'bitacora'"
            [attr.aria-selected]="tabEdicion === 'bitacora'"
            (click)="tabEdicion = 'bitacora'"
          >
            Bitácora
            @if (historial.length) {
              <span class="eia-modal__tab-n">{{ historial.length }}</span>
            }
          </button>
        </nav>

        <form class="eia-modal__form" (ngSubmit)="guardarEdicion()">
          @if (tabEdicion === "bitacora") {
            <div class="eia-bitacora eia-bitacora--modal eia-modal__ancho">
              <div class="eia-bitacora__cabeza">
                <span class="eia-bitacora__titulo">Bitácora de cambios</span>
                <span class="eia-bitacora__estado" [class.eia-bitacora__estado--error]="!!historialError">{{ historialEstado }}</span>
              </div>
              <ol class="eia-bitacora__lista">
                @for (h of historial; track h.idHistorial) {
                  <li class="eia-bitacora__item">
                    <span class="eia-bitacora__accion" [attr.data-accion]="h.accion">{{ accionTexto(h.accion) }}</span>
                    <span class="eia-bitacora__detalle">{{ h.detalle }}</span>
                    <span class="eia-bitacora__quien">{{ h.usuario || "—" }} · {{ h.fecha }}</span>
                  </li>
                }
              </ol>
            </div>
          } @else {
          <div class="eia-campo eia-modal__ancho">
            <div class="eia-campo__cabeza">
              <label for="eia-editar-nombre">Proveedor / herramienta <span class="eia-req" aria-hidden="true">*</span></label>
              <span class="eia-contador">{{ edicion.datos.nombre.length }}/120</span>
            </div>
            <input id="eia-editar-nombre" class="eia-input" name="edNombre" [(ngModel)]="edicion.datos.nombre" maxlength="120" required autocomplete="off" [disabled]="edicion.firmada || guardandoEdicion" />
          </div>
          <div class="eia-campo eia-modal__ancho">
            <div class="eia-campo__cabeza">
              <label for="eia-editar-caso">Caso de uso previsto en {{ EMPRESA }} <span class="eia-req" aria-hidden="true">*</span></label>
              <span class="eia-contador">{{ edicion.datos.casoUso.length }}/300</span>
            </div>
            <input id="eia-editar-caso" class="eia-input" name="edCaso" [(ngModel)]="edicion.datos.casoUso" maxlength="300" required autocomplete="off" [disabled]="edicion.firmada || guardandoEdicion" />
          </div>
          <div class="eia-campo">
            <div class="eia-campo__cabeza">
              <label for="eia-editar-razon">Razón social / entidad</label>
              <span class="eia-contador">{{ edicion.datos.razonSocial.length }}/150</span>
            </div>
            <input id="eia-editar-razon" class="eia-input" name="edRazon" [(ngModel)]="edicion.datos.razonSocial" maxlength="150" autocomplete="off" [disabled]="edicion.firmada || guardandoEdicion" />
          </div>
          <div class="eia-campo">
            <div class="eia-campo__cabeza">
              <label for="eia-editar-servicio">Servicio contratado</label>
              <span class="eia-contador">{{ edicion.datos.servicio.length }}/150</span>
            </div>
            <input id="eia-editar-servicio" class="eia-input" name="edServicio" [(ngModel)]="edicion.datos.servicio" maxlength="150" autocomplete="off" [disabled]="edicion.firmada || guardandoEdicion" />
          </div>
          <div class="eia-campo">
            <div class="eia-campo__cabeza">
              <label for="eia-editar-plan">Plan / modalidad</label>
              <span class="eia-contador">{{ edicion.datos.planModalidad.length }}/100</span>
            </div>
            <input id="eia-editar-plan" class="eia-input" name="edPlan" [(ngModel)]="edicion.datos.planModalidad" maxlength="100" autocomplete="off" [disabled]="edicion.firmada || guardandoEdicion" />
          </div>
          <div class="eia-campo">
            <div class="eia-campo__cabeza">
              <label for="eia-editar-fecha">Fecha de evaluación</label>
            </div>
            <input id="eia-editar-fecha" type="date" class="eia-input" name="edFecha" [(ngModel)]="edicion.datos.fechaEvaluacion" [max]="hoy" [disabled]="edicion.firmada || guardandoEdicion" />
          </div>
          }
          <div class="eia-modal__pie eia-modal__ancho">
            <span class="eia-modal__error" role="alert" [attr.data-tono]="edicionTono">{{ edicionError }}</span>
            @if (edicion.firmada) {
              <span class="eia-mini-12">Firmada: es evidencia de auditoría. Para cambiarla hay que reabrirla desde su resultado.</span>
              <button type="button" class="eia-btn eia-btn--secundario" (click)="cerrarEdicion()">Cerrar</button>
            } @else {
              <button type="button" class="eia-btn eia-btn--secundario" [disabled]="guardandoEdicion" (click)="cerrarEdicion()">Cancelar</button>
              <button type="submit" class="eia-btn eia-btn--primario" [disabled]="guardandoEdicion || edicionSinCambios || !edicion.datos.nombre.trim() || !edicion.datos.casoUso.trim()">
                {{ guardandoEdicion ? "Guardando…" : "Guardar cambios" }}
              </button>
            }
          </div>
        </form>
      </div>
    </div>
  }

  <!-- Vista previa de la evidencia: fija a la ventana, para que no la recorte el marco -->
  @if (vistazo) {
    <div
      id="eia-vistazo"
      class="eia-vistazo"
      role="tooltip"
      [class.eia-vistazo--arriba]="vistazo.arriba"
      [style.left.px]="vistazo.x"
      [style.top.px]="vistazo.y"
      [style.width.px]="vistazo.ancho"
      (mouseenter)="cancelaCierre()"
      (mouseleave)="cierraVistazo()"
    >
      <div class="eia-vistazo__cabeza">
        <span class="eia-vistazo__nombre">{{ vistazo.a.nombreArchivo }}</span>
        <span class="eia-vistazo__meta">{{ vistazo.meta }}</span>
      </div>
      <div class="eia-vistazo__cuerpo" [attr.data-tipo]="vistazo.tipo">
        @switch (vistazo.estado) {
          @case ("cargando") {
            <div class="eia-vistazo__aviso">Cargando la vista previa…</div>
          }
          @case ("error") {
            <div class="eia-vistazo__aviso">No se pudo cargar la vista previa.</div>
          }
          @case ("grande") {
            <div class="eia-vistazo__aviso">Es muy grande para verlo aquí: ábrelo completo.</div>
          }
          @case ("sin") {
            <div class="eia-vistazo__aviso">Este tipo de archivo no tiene vista previa; al abrirlo se baja.</div>
          }
          @default {
            @if (vistazo.urlImagen) {
              <img class="eia-vistazo__img" [src]="vistazo.urlImagen" [alt]="'Vista previa de ' + vistazo.a.nombreArchivo" />
            } @else if (vistazo.urlPdf) {
              <iframe class="eia-vistazo__pdf" [src]="vistazo.urlPdf" [title]="'Vista previa de ' + vistazo.a.nombreArchivo" tabindex="-1"></iframe>
            }
          }
        }
      </div>
      <div class="eia-vistazo__pie">
        <button type="button" class="eia-btn eia-btn--secundario eia-btn--mini" (click)="verArchivo(vistazo.a)">
          {{ vistazo.tipo === "otro" ? "Bajar archivo" : "Abrir completo" }}
        </button>
      </div>
    </div>
  }
</div>
